const API_URL = 'https://mfu.goalstox.com/admin/api/';
const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting };